export default {
  /**
   * Look a cookie and return results
   *
   * @param {string} cname
   * @returns {string}
   */
  getCookie(cname) {
    const name = `${cname}=`;
    const ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i += 1) {
      let c = ca[i];
      while (c.charAt(0) === ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) === 0) {
        return c.substring(name.length, c.length);
      }
    }
    return '';
  },

  /**
   * Delete a specfic cookie
   *
   * @param {string} name
   */
  deleteCookie(name) {
    let domain = '';
    if (process.env.NODE_ENV !== 'development') {
      domain = `domain=${window.location.href.replace(/^(?:https?:\/\/)?(?:[^/]+\.)?([^./]+\.[^./]+).*$/, '$1')};`;
    }
    document.cookie = `${name}=; ${domain} path=/; expires=Thu, 01 Jan 1970 00:00:01 GMT;`;

    /*
      TODO: REMOVE THIS NEXT SNIPPET
      We want this in place to remove any "old" cookies,
      but we really only need it until they expire (every 24 hours)
      so by the time *you* read this, you can remove it
    */
    if (process.env.NODE_ENV !== 'development') {
      document.cookie = `${name}=; path=/; expires=Thu, 01 Jan 1970 00:00:01 GMT;`;
    }
  },

  /**
   * Set a cookie
   *
   * @param {string} name
   * @param {string} value
   * @param {Date} expirationDate
   */
  setCookie(name, value, expirationDate = new Date(new Date().getTime() + (24 * 60 * 60 * 1000))) {
    const domain = process.env.NODE_ENV !== 'testing'
      ? window.location.hostname
      : 'localhost';

    let cookie = `${name}=${value}; expires=${expirationDate.toUTCString()}; path=/; secure;`;

    if (process.env.NODE_ENV !== 'development') {
      cookie += ` domain=${domain}`;
    }
    document.cookie = cookie;
  },
};
